import React from 'react';
import SelectInputComponentLegacy from './SelectInputComponent';
import { FlowsQuestion } from '../../../../types/FlowsTypes';
import {
  isAskaFlow,
  isCitizinsFlow,
} from '../../../../../../common/src/utils/globalVariables';
import SelectInputComponent from '../../company-scan-inputs/select/SelectInputComponent';

interface Props {
  question: FlowsQuestion;
  isSmallDesktopDisplay?: boolean;
}

const SelectInputPicker: React.FC<React.PropsWithChildren<Props>> = ({
  question,
  isSmallDesktopDisplay,
}) => {
  if (isAskaFlow() || isCitizinsFlow()) {
    return <SelectInputComponent question={question} />;
  }

  return (
    <SelectInputComponentLegacy
      question={question}
      isSmallDesktopDisplay={isSmallDesktopDisplay}
    />
  );
};

export default SelectInputPicker;
